import {
    languages,
    defaultLanguage,
    languageByAlias,
} from 'src/common/constants';
import querystring from './queryString';

const getLanguageFromLocation = () => {
    const { location } = window;
    if (!location) return defaultLanguage;
    const { search } = location;
    let { locale } = querystring(search);
    locale = locale?.toLowerCase();
    const savedLang = null;

    if (!locale || !languages.includes(locale)) {
        return savedLang || defaultLanguage;
    }
    return languageByAlias[locale];
};

export default getLanguageFromLocation;
